import React from 'react';

import {
  Action,
  Actions,
  PendingActionsIcon,
  DoneIcon,
  DeleteIcon,
  EditIcon,
  FileCopyIcon,
  StopIcon,
  PlayArrowIcon,
  NotInterestedIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_START,
  ACTION_STOP,
  ACTION_EDIT,
  ACTION_COPY,
  ACTION_APPROVE,
  ACTION_REJECT,
  ACTION_REMOVE,
} from 'scenes/SmartRules/constants';

export const ActionsComponent = ({
  actions,
  limit = 1,
  className,
  disabled,
  onApprove,
  onReject,
  onEdit,
  onStart,
  onStop,
  disabledByInspection,
  onCopy,
  onDelete,
  withViewLog,
  onViewLog,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Actions limit={limit} className={className}>
          {withViewLog ? (
            <Action
              id={'viewLog'}
              icon={<PendingActionsIcon />}
              label={'View log'}
              onClick={onViewLog}
            />
          ) : null}
          {isActionAllowed(ACTION_APPROVE) ? (
            <Action
              id={'approve'}
              label={'Approve'}
              icon={<DoneIcon />}
              onClick={onApprove}
              disabled={disabled}
            />
          ) : null}
          {isActionAllowed(ACTION_REJECT) ? (
            <Action
              id={'reject'}
              label={'Reject'}
              icon={<NotInterestedIcon />}
              onClick={onReject}
              disabled={disabled}
            />
          ) : null}
          {isActionAllowed(ACTION_START) ? (
            <Action
              id={'start'}
              label={'Activate'}
              icon={<PlayArrowIcon />}
              onClick={onStart}
              disabled={disabled}
            />
          ) : null}

          {isActionAllowed(ACTION_STOP) ? (
            <Action
              id={'stop'}
              label={'Deactivate'}
              icon={<StopIcon />}
              onClick={onStop}
              disabled={disabled}
            />
          ) : null}

          <Action
            id={'duplicate'}
            label={'Duplicate'}
            icon={<FileCopyIcon />}
            onClick={onCopy}
            disabled={disabledByInspection || !isActionAllowed(ACTION_COPY)}
          />
          <Action
            id={'edit'}
            label={'Edit'}
            icon={<EditIcon />}
            onClick={onEdit}
            disabled={disabled || !isActionAllowed(ACTION_EDIT)}
          />
          <Action
            id={'delete'}
            label={'Delete'}
            icon={<DeleteIcon />}
            onClick={onDelete}
            disabled={disabled || !isActionAllowed(ACTION_REMOVE)}
          />
        </Actions>
      )}
    </Permissions>
  );
};
